import { render, staticRenderFns } from "./WorkItemBulkModal.html?vue&type=template&id=0aef58fa&external"
import script from "./WorkItemBulkModal.ts?vue&type=script&lang=ts&external"
export * from "./WorkItemBulkModal.ts?vue&type=script&lang=ts&external"
import style0 from "./WorkItemBulkModal.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports